import { Button, styled } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import React, { useState } from 'react';
import { DropzoneDialog } from 'mui-file-dropzone';
import Flex from 'ui/Flex/Flex';
import ColorPicker from 'ui/ColorPicker/ColorPicker';
import { sideBarLogoDimensions } from 'components/SideBar/helpers';
import { useTranslation } from 'react-i18next';
import { convertFileToBase64 } from 'ui/TextEditor/helpers';
import { ClientPalette } from '../ModuleForm/helpers/types';

const StyLogoImage = styled('img', {
    name: 'StyLogoImage',
})({
    objectFit: 'contain',
    ...sideBarLogoDimensions(false),
    backgroundColor: 'white',
    marginRight: '1.5rem',
    border: '1px solid',
    borderColor: 'grey',
});

const CustomizationForm = ({
    palette,
    setPalette,
}: {
    palette: ClientPalette;
    setPalette: (palette: ClientPalette) => void;
}) => {
    const { t } = useTranslation();
    const [openLogoDropzone, setOpenLogoDropzone] = useState(false);
    const { primaryColor, secondaryColor, logoUrl } = palette;

    return (
        <Flex margin="10px" direction="column">
            <Flex align="center" margin="10px">
                {logoUrl !== '' && <StyLogoImage src={logoUrl} />}
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ height: '1rem', width: '200px' }}
                    onClick={() => setOpenLogoDropzone(true)}
                    startIcon={<FileUploadIcon fontSize="small" />}
                >
                    {t('support.clientConfiguration.customization.addImage')}
                </Button>
            </Flex>
            <Flex align="center" margin="10px">
                <Flex marginRight="20px">
                    <ColorPicker
                        sx={{ mr: '20px' }}
                        value={primaryColor}
                        setValue={(value: string) =>
                            setPalette({
                                ...palette,
                                primaryColor: value,
                            })
                        }
                        label={t(
                            'support.clientConfiguration.customization.primaryColor',
                        )}
                    />
                </Flex>
                <Flex>
                    <ColorPicker
                        value={secondaryColor}
                        setValue={(value: string) =>
                            setPalette({
                                ...palette,
                                secondaryColor: value,
                            })
                        }
                        label={t(
                            'support.clientConfiguration.customization.secondaryColor',
                        )}
                    />
                </Flex>
            </Flex>
            <DropzoneDialog
                open={openLogoDropzone}
                acceptedFiles={['image/*']}
                fileObjects={[]}
                showPreviews={false}
                dialogTitle=""
                dropzoneText={t(
                    'support.clientConfiguration.customization.addImage',
                )}
                previewGridProps={{
                    container: {
                        display: 'flex',
                        justifyContent: 'center',
                    },
                }}
                cancelButtonText={t('common.cancel')}
                submitButtonText={t('common.confirm')}
                showPreviewsInDropzone
                onClose={() => setOpenLogoDropzone(false)}
                onSave={(files: File[]) => {
                    convertFileToBase64(files[0]).then((newLogo: string) => {
                        setPalette({
                            ...palette,
                            logoUrl: newLogo,
                        });
                        setOpenLogoDropzone(false);
                    });
                }}
            />
        </Flex>
    );
};

export default React.memo(CustomizationForm);
